export default [
  {
    path: '',
    component: () => import('src/pages/adminDashboard/index.vue')
  },
  {
    path: 'SuiviSchema',
    component: () => import('src/pages/adminDashboard/SuiviSchema/index.vue')
  },
  {
    path: 'BrowserStats',
    component: () => import('src/pages/adminDashboard/BrowserStats/index.vue')
  },
  {
    path: 'ServerSettings',
    component: () => import('src/pages/adminDashboard/ServerSettings/index.vue')
  },
  {
    path: 'Survey',
    component: () => import('src/pages/adminDashboard/Survey/index.vue')
  }
];
